<template>
	<div style="box-sizing: border-box;padding: 10px;padding-bottom:100px;min-height: 100%;" v-loading="loading">
		<v-jstree ref="jstree" size="small" text-field-name="name" value-field-name="id" :data="modulelist" collapse
			@item-click="itemClick" v-if="modulelist.length!=0"></v-jstree>
	</div>
</template>
<style scoped>


</style>
<script>
	import VJstree from 'vue-jstree'
	export default {
		props: {

		},
		data() {
			return {
				loading: false,
				modulelist: [],
				modulesource: [],
				currentObj: null,
				currentItem: {
					id: 0,
					name: ''
				},
				currentChildren: [],
			}
		},
		created() {

			this.list()
		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},

		methods: {
			list() {
				this.loading = true
				this.modulelist = []
				this.$api.module.list().then((res) => {
					let list = res.list
					list.forEach((item) => {
						item.icon = ''
					})
					let root = []
					list.forEach((item) => {
						if (item.parentid == 0) {
							root.push(item)
						} else {
							list.forEach((_item) => {
								if (item.parentid == _item.id) {
									if (!_item.children) {
										_item.children = []
									}
									_item.children.push(item)
								}
							})
						}
					})
					this.modulelist = root
					this.modulesource = list
					this.loading = false

				})
			},
			itemClick(node, item, e) {

				this.currentObj = node
				this.currentItem = item
				//console.log(node)
				let parentbread = [{
					id: item.id,
					name: item.name
				}]
				this.createParenBread(item, parentbread)
				//console.log(bread)
				this.currentChildren = [item.id]
				this.findcildren([item.id])

				this.$emit('select', {
					id: item.id,
					name: item.name,
					component: item.component,
					controller: item.controller,
					parentbread: parentbread,
					children: this.currentChildren,
					toolbarbutton: item.toolbarbutton,
					operatebutton: item.operatebutton,
					listfield: item.listfield?item.listfield.listfield:[]
				})
				e.stopPropagation()
			},
			updateNode(node) {
				for (let i in node) {
					this.currentItem[i] = node[i]
				}
			},
			addNode(node) {
				this.currentItem.addChild(node)
			},
			removeNode() {
				let index = this.currentObj.parentItem.indexOf(this.currentItem)
				this.currentObj.parentItem.splice(index, 1)
			},
			unSelectNode() {
				this.currentItem.selected = false
				this.currentItem = {
					id: 0,
					name: ''
				}
			},
			// clickBlank() {
			// 	if (this.currentObj) {
			// 		this.currentObj.model.selected = false
			// 		this.$emit('select', {
			// 			id: 0,
			// 			name: ''
			// 		})
			// 	}
			// },
			createParenBread(item, bread) {
				if (item.parentid == 0) {
					return item
				} else {
					for (let i = 0; i < this.modulesource.length; i++) {
						if (item.parentid == this.modulesource[i].id) {
							bread.unshift({
								name: this.modulesource[i].name,
								id: this.modulesource[i].id
							})
							this.createParenBread(this.modulesource[i], bread)
						}
					}
				}
			},
			findcildren(moduleids) {
				let childrenid = []
				moduleids.forEach((moduleid) => {
					this.modulesource.forEach((item) => {
						if (item.parentid == moduleid) {
							childrenid.push(item.id)
						}
					})
				})
				if (childrenid.length != 0) {
					this.currentChildren = this.currentChildren.concat(childrenid)
					this.findcildren(childrenid)
				}
			},
			getmodulebyid(id) {
				for (let i = 0; i < this.modulesource.length; i++) {
					console.log(this.modulesource[i].id)
					if (this.modulesource[i].id == id) {

						return this.modulesource[i]
					}
				}
				return {
					name: '未知'
				}
			}
		},
		components: {
			VJstree
		}
	}
</script>
